export default __webpack_public_path__ + "assets/pdf/cvWebsiteSchottenhammer.b7138eeb.pdf";